import React, { useEffect } from 'react';
import { useUpdateShare } from './atom';

// stateKey is an array used with loadsh for nested cases

function useShareSet({ pageKey, state }) {

  const { updateData } = useUpdateShare({ pageKey });

  useEffect(() => {
    updateData(state)

    // remove data on unmount
    return () => {
      updateData({})
    }
  }, [pageKey, state]);
}

export default useShareSet;
